function getStaticUrl() {
  return 'https://static.hubspot.com';
}
export default getStaticUrl;